export default `
    <link href='/snippets-style/brand-info.css' rel='stylesheet' />
    <div class="ro-footer--brandWrap">
      <div class="ro-footer--brandInfo">
        <div class="ro-footer--brandInfo__txt">
            Favbet.ro products are owned and operated by Favbet Online, a company based in Bucharest on Calea Grivitei, no. 136, registered under number J40/14188/18.11.2015, with a share capital of RON 1,000,100 and the fiscal registration number 35246629.
        </div>
      </div>
    </div>
    <div class="ro-footer--brandWrap">
      <div class="copyright">© 2020 FavBet. All rights reserved.</div>
    </div>
`;
